import { type FC } from 'react'

import { type ZouIllustrationBaseProps } from '@DS/components/illustrations/types'
import { ReactComponent as WarningBackgroundDark } from '@Svg/illustrations/zou/warning/background_dark.svg'
import { ReactComponent as WarningBackgroundLight } from '@Svg/illustrations/zou/warning/background_light.svg'
import { ReactComponent as WarningSimpleDark } from '@Svg/illustrations/zou/warning/simple_dark.svg'
import { ReactComponent as WarningSimpleLight } from '@Svg/illustrations/zou/warning/simple_light.svg'

import BaseIllustration from '../_internal/BaseIllustration'

const Warning: FC<ZouIllustrationBaseProps> = (props) => (
  <BaseIllustration
    {...props}
    illustrations={{
      background: { dark: WarningBackgroundDark, light: WarningBackgroundLight },
      simple: { dark: WarningSimpleDark, light: WarningSimpleLight },
    }}
  />
)

export default Warning
